<div class="details">
  <div class="details-column details-column-included">
    <div class="details-column-header">
      <i class="pi pi-check"></i>
      <span [innerHTML]="'price-range.included.title' | translate"></span>
    </div>
    <span class="details-column-subtitle" [innerHTML]="'price-range.included.subtitle' | translate"></span>
    @if (loading) {
      <div class="details-list">
        @for (width of skeletonWidths[0]; track $index) {
          <p-skeleton [width]="width" height="1rem"></p-skeleton>
        }
      </div>
    } @else {
      <ul class="details-list">
        @for (item of included; track item) {
          <li class="details-item">{{ item }}</li>
        }
      </ul>
    }
  </div>

  <div class="details-column details-column-to-validate">
    <div class="details-column-header">
      <i class="pi pi-exclamation-triangle"></i>
      <span [innerHTML]="'price-range.to-validate.title' | translate"></span>
    </div>
    <span class="details-column-subtitle" [innerHTML]="'price-range.to-validate.subtitle' | translate"></span>
    @if (loading) {
      <div class="details-list">
        @for (width of skeletonWidths[1]; track $index) {
          <p-skeleton [width]="width" height="1rem"></p-skeleton>
        }
      </div>
    } @else {
      <ul class="details-list">
        @for (item of toValidate; track item) {
          <li class="details-item">{{ item }}</li>
        }
      </ul>
    }
  </div>

  <div class="details-column details-column-excluded">
    <div class="details-column-header">
      <i class="pi pi-times"></i>
      <span [innerHTML]="'price-range.excluded.title' | translate"></span>
    </div>
    <span class="details-column-subtitle" [innerHTML]="'price-range.excluded.subtitle' | translate"></span>
    @if (loading) {
      <div class="details-list">
        @for (width of skeletonWidths[2]; track $index) {
          <p-skeleton [width]="width" height="1rem"></p-skeleton>
        }
      </div>
    } @else {
      <ul class="details-list">
        @for (item of excluded; track item) {
          <li class="details-item">{{ item }}</li>
        }
      </ul>
    }
  </div>
</div>
